(function(ws) {
    'use strict';

    ws.views.recentSavedShoppingCarts = ws.views.recentItems.extend({
        GTM_EVENT_ACTION: 'click_saved_shopping_cart',
        GTM_EVENT_LABEL: 'cart_name_link',

        ADOBE_EVENT_ACTION: 'saved carts'
    });
})(westcon);
